// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InlineFeedback.css - Figma Design System Feedback & Loading States */
[data-draft-save-confirmation] {
  margin-bottom: var(--space-4, 16px); }

[data-draft-save-confirmation]:empty {
  display: none; }

.quotation-editor-header > [data-draft-save-confirmation] {
  margin-bottom: 0; }

.inline-feedback-container {
  width: 100%;
  box-sizing: border-box;
  margin: 12px 0 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px; }

.inline-feedback-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 14px;
  border-radius: var(--radius-md, 10px);
  font-family: var(--font-family-primary, "Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.04);
  animation: inline-feedback-slide-in 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  transition: opacity 0.2s ease, transform 0.2s ease; }

@keyframes inline-feedback-slide-in {
  from {
    opacity: 0;
    transform: translateY(-6px); }
  to {
    opacity: 1;
    transform: translateY(0); } }

/* Error variant */
.inline-feedback-banner--error {
  background: var(--danger-soft, #fef2f1);
  border: 1px solid var(--danger-border, #fecaca);
  color: var(--danger-text, #a3301f); }

.inline-feedback-banner--error .inline-feedback-icon {
  color: var(--danger-default, #c23a2b); }

/* Success variant */
.inline-feedback-banner--success {
  background: var(--success-soft, #edfbf2);
  border: 1px solid var(--success-border, #bbf7d0);
  color: var(--success-text, #115a33); }

.inline-feedback-banner--success .inline-feedback-icon {
  color: var(--success-default, #15703d); }

/* Warning variant */
.inline-feedback-banner--warning {
  background: var(--warning-soft, #fef8ec);
  border: 1px solid var(--warning-border, #fde68a);
  color: var(--warning-text, #7d4412); }

.inline-feedback-banner--warning .inline-feedback-icon {
  color: var(--warning-default, #b7701a); }

/* Info variant */
.inline-feedback-banner--info {
  background: var(--info-soft, #eff6ff);
  border: 1px solid var(--info-border, #bfdbfe);
  color: var(--info-text, #315b8f); }

.inline-feedback-banner--info .inline-feedback-icon {
  color: var(--info-default, #1a73e8); }

.inline-feedback-icon {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  display: flex;
  align-items: center;
  justify-content: center; }

.inline-feedback-icon svg {
  width: 18px;
  height: 18px;
  display: block; }

.inline-feedback-text {
  flex: 1 1;
  min-width: 0;
  word-break: break-word; }

.inline-feedback-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: auto;
  flex: 0 0 22px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: currentColor;
  opacity: 0.65;
  cursor: pointer;
  transition: opacity 0.15s ease, background-color 0.15s ease; }

.inline-feedback-close:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.05); }

.inline-feedback-close svg {
  width: 14px;
  height: 14px; }

/* Field validation message (12px Lexend directly under inputs) */
.inline-field-error {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  color: var(--danger-default, #c23a2b);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  animation: inline-feedback-slide-in 0.2s ease-out; }

.inline-field-error svg {
  width: 13px;
  height: 13px;
  flex: 0 0 13px; }

.inline-field-success {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  color: var(--success-default, #15703d);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px; }

/* Compact action feedback pill (placed next to Save / Send buttons) */
.inline-action-message {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.04);
  animation: inline-feedback-slide-in 0.2s ease-out; }

.inline-action-message--error {
  background: var(--danger-soft, #fef2f1);
  border: 1px solid var(--danger-border, #fecaca);
  color: var(--danger-text, #a3301f); }

.inline-action-message--success {
  background: var(--success-soft, #edfbf2);
  border: 1px solid var(--success-border, #bbf7d0);
  color: var(--success-text, #115a33); }

.inline-action-message--warning {
  background: var(--warning-soft, #fef8ec);
  border: 1px solid var(--warning-border, #fde68a);
  color: var(--warning-text, #7d4412); }

.inline-action-message--info {
  background: var(--info-soft, #eff6ff);
  border: 1px solid var(--info-border, #bfdbfe);
  color: var(--info-text, #315b8f); }

.inline-action-message svg {
  width: 14px;
  height: 14px;
  flex: 0 0 14px; }

/* Button loading state utilities */
.btn-loading,
.button-loading {
  position: relative !important;
  cursor: wait !important;
  pointer-events: none !important;
  opacity: 0.85 !important; }

.btn-loading .btn-spinner,
.button-loading .button-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: inline-button-spinner 0.65s linear infinite;
  vertical-align: middle;
  flex-shrink: 0;
  margin-right: 6px; }

@keyframes inline-button-spinner {
  to {
    transform: rotate(360deg); } }

/* Dark mode adjustments */
html[data-theme="dark"] .inline-feedback-banner--error,
.dark .inline-feedback-banner--error {
  background: #332022;
  border-color: #614047;
  color: #f3aaa4; }

html[data-theme="dark"] .inline-feedback-banner--error .inline-feedback-icon,
.dark .inline-feedback-banner--error .inline-feedback-icon {
  color: #f08078; }

html[data-theme="dark"] .inline-feedback-banner--success,
.dark .inline-feedback-banner--success {
  background: #193328;
  border-color: #38644f;
  color: #a7e9c5; }

html[data-theme="dark"] .inline-feedback-banner--success .inline-feedback-icon,
.dark .inline-feedback-banner--success .inline-feedback-icon {
  color: #5ed89c; }

html[data-theme="dark"] .inline-feedback-close:hover,
.dark .inline-feedback-close:hover {
  background-color: rgba(255, 255, 255, 0.1); }
`, "",{"version":3,"sources":["webpack://./src/components/InlineFeedback/InlineFeedback.css"],"names":[],"mappings":"AAAA,uEAAA;AACA;EAEE,mCAAmC,EAAA;;AACrC;EAGE,aAAa,EAAA;;AAGf;EACE,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,oHAQC;EACD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,uEAAuE;EACvE,kDAAkD,EAAA;;AAGpD;EACE;IACE,UAAU;IACV,2BAA2B,EAAA;EAE7B;IACE,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAI5B,kBAAA;AACA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,kCAAkC,EAAA;;AAGpC;EACE,qCAAqC,EAAA;;AAGvC,oBAAA;AACA;EACE,wCAAwC;EACxC,gDAAgD;EAChD,mCAAmC,EAAA;;AAGrC;EACE,sCAAsC,EAAA;;AAGxC,oBAAA;AACA;EACE,wCAAwC;EACxC,gDAAgD;EAChD,mCAAmC,EAAA;;AAGrC;EACE,sCAAsC,EAAA;;AAGxC,iBAAA;AACA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,gCAAgC,EAAA;;AAGlC;EACE,mCAAmC,EAAA;;AAGrC;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,2DAA2D,EAAA;;AAG7D;EACE,UAAU;EACV,qCAAqC,EAAA;;AAGvC;EACE,WAAW;EACX,YAAY,EAAA;;AAGd,iEAAA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iDAAiD,EAAA;;AAGnD;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sCAAsC;EACtC,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB,sEAAA;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,iDAAiD,EAAA;;AAGnD;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,kCAAkC,EAAA;;AAGpC;EACE,wCAAwC;EACxC,gDAAgD;EAChD,mCAAmC,EAAA;;AAGrC;EACE,wCAAwC;EACxC,gDAAgD;EAChD,mCAAmC,EAAA;;AAGrC;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,gCAAgC,EAAA;;AAGlC;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB,mCAAA;AACA;;EAEE,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB,EAAA;;AAG1B;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,8BAA8B;EAC9B,kBAAkB;EAClB,sDAAsD;EACtD,sBAAsB;EACtB,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE;IACE,yBAAyB,EAAA,EAAA;;AAI7B,0BAAA;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc,EAAA;;AAGhB;;EAEE,cAAc,EAAA;;AAGhB;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc,EAAA;;AAGhB;;EAEE,cAAc,EAAA;;AAGhB;;EAEE,0CAA0C,EAAA","sourcesContent":["/* InlineFeedback.css - Figma Design System Feedback & Loading States */\n\n[data-draft-save-confirmation] {\n  margin-bottom: var(--space-4, 16px);\n}\n\n[data-draft-save-confirmation]:empty {\n  display: none;\n}\n\n.quotation-editor-header > [data-draft-save-confirmation] {\n  margin-bottom: 0;\n}\n\n.inline-feedback-container {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 12px 0 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.inline-feedback-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 14px;\n  border-radius: var(--radius-md, 10px);\n  font-family: var(\n    --font-family-primary,\n    \"Lexend\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif\n  );\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.04);\n  animation: inline-feedback-slide-in 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n@keyframes inline-feedback-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Error variant */\n.inline-feedback-banner--error {\n  background: var(--danger-soft, #fef2f1);\n  border: 1px solid var(--danger-border, #fecaca);\n  color: var(--danger-text, #a3301f);\n}\n\n.inline-feedback-banner--error .inline-feedback-icon {\n  color: var(--danger-default, #c23a2b);\n}\n\n/* Success variant */\n.inline-feedback-banner--success {\n  background: var(--success-soft, #edfbf2);\n  border: 1px solid var(--success-border, #bbf7d0);\n  color: var(--success-text, #115a33);\n}\n\n.inline-feedback-banner--success .inline-feedback-icon {\n  color: var(--success-default, #15703d);\n}\n\n/* Warning variant */\n.inline-feedback-banner--warning {\n  background: var(--warning-soft, #fef8ec);\n  border: 1px solid var(--warning-border, #fde68a);\n  color: var(--warning-text, #7d4412);\n}\n\n.inline-feedback-banner--warning .inline-feedback-icon {\n  color: var(--warning-default, #b7701a);\n}\n\n/* Info variant */\n.inline-feedback-banner--info {\n  background: var(--info-soft, #eff6ff);\n  border: 1px solid var(--info-border, #bfdbfe);\n  color: var(--info-text, #315b8f);\n}\n\n.inline-feedback-banner--info .inline-feedback-icon {\n  color: var(--info-default, #1a73e8);\n}\n\n.inline-feedback-icon {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inline-feedback-icon svg {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n.inline-feedback-text {\n  flex: 1;\n  min-width: 0;\n  word-break: break-word;\n}\n\n.inline-feedback-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin-left: auto;\n  flex: 0 0 22px;\n  padding: 0;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: currentColor;\n  opacity: 0.65;\n  cursor: pointer;\n  transition: opacity 0.15s ease, background-color 0.15s ease;\n}\n\n.inline-feedback-close:hover {\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.inline-feedback-close svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* Field validation message (12px Lexend directly under inputs) */\n.inline-field-error {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n  color: var(--danger-default, #c23a2b);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  animation: inline-feedback-slide-in 0.2s ease-out;\n}\n\n.inline-field-error svg {\n  width: 13px;\n  height: 13px;\n  flex: 0 0 13px;\n}\n\n.inline-field-success {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n  color: var(--success-default, #15703d);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n/* Compact action feedback pill (placed next to Save / Send buttons) */\n.inline-action-message {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.04);\n  animation: inline-feedback-slide-in 0.2s ease-out;\n}\n\n.inline-action-message--error {\n  background: var(--danger-soft, #fef2f1);\n  border: 1px solid var(--danger-border, #fecaca);\n  color: var(--danger-text, #a3301f);\n}\n\n.inline-action-message--success {\n  background: var(--success-soft, #edfbf2);\n  border: 1px solid var(--success-border, #bbf7d0);\n  color: var(--success-text, #115a33);\n}\n\n.inline-action-message--warning {\n  background: var(--warning-soft, #fef8ec);\n  border: 1px solid var(--warning-border, #fde68a);\n  color: var(--warning-text, #7d4412);\n}\n\n.inline-action-message--info {\n  background: var(--info-soft, #eff6ff);\n  border: 1px solid var(--info-border, #bfdbfe);\n  color: var(--info-text, #315b8f);\n}\n\n.inline-action-message svg {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 14px;\n}\n\n/* Button loading state utilities */\n.btn-loading,\n.button-loading {\n  position: relative !important;\n  cursor: wait !important;\n  pointer-events: none !important;\n  opacity: 0.85 !important;\n}\n\n.btn-loading .btn-spinner,\n.button-loading .button-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: inline-button-spinner 0.65s linear infinite;\n  vertical-align: middle;\n  flex-shrink: 0;\n  margin-right: 6px;\n}\n\n@keyframes inline-button-spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Dark mode adjustments */\nhtml[data-theme=\"dark\"] .inline-feedback-banner--error,\n.dark .inline-feedback-banner--error {\n  background: #332022;\n  border-color: #614047;\n  color: #f3aaa4;\n}\n\nhtml[data-theme=\"dark\"] .inline-feedback-banner--error .inline-feedback-icon,\n.dark .inline-feedback-banner--error .inline-feedback-icon {\n  color: #f08078;\n}\n\nhtml[data-theme=\"dark\"] .inline-feedback-banner--success,\n.dark .inline-feedback-banner--success {\n  background: #193328;\n  border-color: #38644f;\n  color: #a7e9c5;\n}\n\nhtml[data-theme=\"dark\"] .inline-feedback-banner--success .inline-feedback-icon,\n.dark .inline-feedback-banner--success .inline-feedback-icon {\n  color: #5ed89c;\n}\n\nhtml[data-theme=\"dark\"] .inline-feedback-close:hover,\n.dark .inline-feedback-close:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
